export const isMsTeamsApp = (): boolean => window.location.href.includes("msteams");
